/* eslint-disable no-console,no-undef,camelcase */
import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";

import {
  Layout,
  Container,
  InputContainer,
  //   StyledInputV2,
  StyledLabel,
  ButtonContainer,
  EditorContainer,
} from "../CreateEvent/style";

import {  closeIcon,  RecognitionCloseIcon, UploadHDMIcon} from "../../utils/icons";
import { CommonButtonPopup } from "../ReportsV2/styles";
import { CommonButtonBorder } from "../common/commonStyles";
import { Border } from "../Journeys/styles";
import { FormHeading } from "../ChallengeCreationAdmin/ActivityChallengeLaunch/style";
import { ManagerIconContainer } from "../Manager/styles";
import CommonImageUploader from "../common/CommonImageUploader/CommonImageUploader";
import Editor from "../CKEditor";
import { Main } from "../AdminTeamCreation/styles";
import StepsHeading from "../../components/RecogntionAdmin/corevalues/stepNames";
import { AddWellnessChallengeCategory, GetWellbeingPillars } from "../../redux/constants/apiConstants";
import { toast } from "react-toastify";
import { fetchApi } from "../../utils/methods";
import CommonDropdownWellness from "../common/CommonDropDown/CommonDropdownWellness";


class CreateCategoryForm extends Component {
  constructor() {
    super();
    this.state = {
      description: "",
      WellbeingPillars:[],
      imageName: "",
      goldBadgeImageName: "",
      silverBadgeImageName: "",
      bronzeBadgeImageName: "",
      imgSrc: "",
      goldBadgeImgSrc: "",
      silverBadgeImgSrc: "",
      bronzeBadgeImgSrc: "",
      selectedValues:[],
      buttonstatus: false,
      step: 1,
      showBack:false,
      buttonClickScrollTop:false,
      levels:null,
      getCoachData:[],
      charCount:0,
      selectedOption: 0,
      selectedCategory: null,
      selectedCategoryId:null,
    };
  }


  


  onSelectCategoryType = (selectedItem) => {
    this.setState({
      selectedCategory: selectedItem.month+(selectedItem.month?" - ":"")+ selectedItem.theme_text,
      themeId: selectedItem.month_number,
    });
  };

  onChangeInput = (e) => {
    if(e.target.value.charAt(0) !== ' '){
      this.setState({
        [e.target.name]: e.target.value,
      });
    }
  };

  onChangeURL = (e) => {
    if(e.target.value.charAt(0) !== ' '){
      this.setState({
        url: e.target.value,
      });
    }
  };

  onChangeTime = (e) => {
    const numValidate = /^[0-9\b]+$/;
    if (e.target.value === "" || numValidate.test(e.target.value)) {
      this.setState({ time: e.target.value });
    }
  };

  removePhoto = () => {
    this.setState({
      imgSrc: "",
      imageName: "",
    });
  };



  removeGoldImage = () => {
    this.setState({
      goldBadgeImgSrc: "",
      goldBadgeImageName: "",
    });
  };
  
  removeSilverImage = () => {
    this.setState({
      silverBadgeImgSrc: "",
      silverBadgeImageName: "",
    });
  };
  
  removeBronzeImage = () => {
    this.setState({
      bronzeBadgeImgSrc: "",
      bronzeBadgeImageName: "",
    });
  };


  onChange = (baseImage, imageName) => {
    this.setState({
      imgSrc: baseImage,
      imageName: imageName,
    });
  }

  onChangeGoldImage = (baseImage, imageName) => {
    this.setState({
      goldBadgeImgSrc: baseImage,
      goldBadgeImageName: imageName,
    });
  }


  onChangeSilverImage = (baseImage, imageName) => {
    this.setState({
      silverBadgeImgSrc: baseImage,
      silverBadgeImageName: imageName,
    });
  }


  onChangeBronzeImage = (baseImage, imageName) => {
    this.setState({
      bronzeBadgeImgSrc: baseImage,
      bronzeBadgeImageName: imageName,
    });
  }


  onSelectClass = (name, value, key) => {
    const selectedValues = [...this.state[name]];
  
    if (selectedValues.includes(value)) {
      const index = selectedValues.findIndex((item) => item === value);
      if (index > -1) selectedValues.splice(index, 1);
    } else {
      if (selectedValues.length < 5) {
        selectedValues.push(value);
      }
    }
  
    this.setState({
      [name]: selectedValues,
      classTypeKey: key,
      coachId: null,
      coachName: '',
    }, () => {
      if (name === "classCategoryTypeValue") {
        this.fetchCoachData(this.state.classCategoryTypeValue);
      }
    });
  };
  

  eventButtonStatusHover = () => {
    this.setState({
      showBack: true,
    });
  };


  eventButtonStatus = () => {
    this.setState({
      showBack: false,
    });
  };



  getAllWellbeingPillars = async (language) => {
    // setLoader('running');
    try {
      const res = await fetchApi(GetWellbeingPillars + "/" + language, "GET");

      if (res.status === "success") {
        this.setState({WellbeingPillars:res.data});
        // setLoader(null);
      } else {
        toast.error((res.data.message || "Something went wrong"));
        // setLoader(null);

      }
    } catch (error) {
      window.console.error(error);
    //   setLoader(null);
    }
  }; 


  takeLanguageData = (lang) => {
  
    const langCode =
      lang === "en" ? 1 :
        lang === "es" ? 2 :
          lang === "fr" ? 3 :
            lang === "pt" ? 4 : 1;

    // i18n.changeLanguage(lang);
    // localStorage.setItem("lang", lang);
    // this.setState({ lang }); 

    this.getAllWellbeingPillars(langCode);
  };


  componentDidMount (){

    let lang = localStorage.getItem("lang") || "en";
    this.takeLanguageData(lang);
    // this.getAllWellbeingPillars(1);
  }

  saveOndemandEvent = () => {
    const {
      description,
      imgSrc,
      goldBadgeImgSrc,
      silverBadgeImgSrc,
      bronzeBadgeImgSrc,
      selectedCategoryId
    } = this.state;
    // this.setState({
    //   buttonstatus: true,
    // });

    
    const ChallengeCategory = {
      pillar_id: selectedCategoryId,
      image: imgSrc,
      description: description,
      gold_badge_icon: goldBadgeImgSrc,
      silver_badge_icon: silverBadgeImgSrc,
      bronze_badge_icon: bronzeBadgeImgSrc,
    };

    this.PostChallengeCategory(ChallengeCategory);
  };


  PostChallengeCategory = async(payload)=>{
    try{
      const res = await fetchApi(AddWellnessChallengeCategory, "POST",payload);

      if(res?.status === "success"){
        toast.success(res.data[0]);
        this.props.history.push({pathname:"/company/challenges/categories", query:{isWellnessCategory:true} })

      }else{
        toast.error(res.data.message);
        // this.setState({
        //   buttonStatus: false,
        // });
      }
    }catch(error){
      toast.error(error);
    }
  }

 

 
  

  onChangeDescription = (evt) => {
    const newContent = evt.getData();
    const trimmedString = newContent.replace(/\s|&nbsp;/g, "");
    trimmedString.length === 0 ||
    trimmedString.length === 7 ||
    trimmedString === "<p></p><p></p>"
      ? this.setState({ description: "" })
      : this.setState({ description: newContent });
 
    const plainText = newContent.replace(/<[^>]*>/g, "").trim(); 
    const currentLength = plainText.length;
    this.setState({charCount: currentLength});
  };

  updateStep = (value) => {
    this.setState({ step: value, buttonClickScrollTop:true });
  };

  close = () =>(
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_14978_75731"
        style={{maskType: "alpha",}}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={24}
        height={24}
      >
        <rect width={24} height={24} fill="#C4C4C4" />
      </mask>
      <g mask="url(#mask0_14978_75731)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.3605 0.678084C22.6358 -0.0466026 21.4608 -0.0466023 20.7361 0.678084L11.9067 9.50756L3.07795 0.678849C2.4145 0.0154025 1.33884 0.0154032 0.675399 0.678849C0.0119522 1.3423 0.0119521 2.41796 0.675399 3.0814L9.50411 11.9101L0.675642 20.7386C-0.0490441 21.4633 -0.0490441 22.6382 0.675643 23.3629C1.40033 24.0876 2.57528 24.0876 3.29996 23.3629L12.1284 14.5344L20.9577 23.3637C21.6211 24.0271 22.6968 24.0271 23.3602 23.3637C24.0237 22.7002 24.0237 21.6246 23.3602 20.9611L14.531 12.1319L23.3605 3.30241C24.0851 2.57772 24.0851 1.40277 23.3605 0.678084Z"
          fill="#9C9C9C"
        />
      </g>
    </svg>
  )

  // redirect=()=>{
  //   this.props.history.goBack();
  // }
  
  renderHeading = () => (
    <FormHeading color={"#184A61"}>
      <div className="close-icon"  onClick={()=> this.props.history.push({pathname: '/company/challenges/categories', query: {isWellnessCategory:true}})}>
        <ManagerIconContainer isWidth={"32px"}>{RecognitionCloseIcon('#F37A65')}</ManagerIconContainer>
      </div>
    Create Wellness Category
    </FormHeading>
  );


  getPillarValues = () => {
    window.console.log("hi")
    return this.state.WellbeingPillars.map((pillar) => ({
      id: pillar.id,
      category_text: pillar.pillar_title, // will display in dropdown
      description: pillar.description,
      category_Already_Added: pillar.added_wellness_challenge_category,

    }));
  };

  onSelectCategory = (item) => {
    this.setState({
      selectedCategory: item.category_text, // show selected text
      selectedCategoryId: item.id,       // keep id for API
      so: false
    });
  };

      
  stepOneForm = () => {
    const {
      // title,
      // url,
      description,
      step,
      charCount,
      //   WellbeingPillars,
      selectedCategory,
    } = this.state;

    const { t } = this.props;

    return (
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container  color="#005C87">
            <div className="stepsNameHighlight">
              <StepsHeading stepCount={step} type="wellness-challenge"/>
            </div>
            <div className="form">
             
              <div className="formBody">

                <CommonDropdownWellness
                  tileContainerStyle={{ width: "100%",padding:"0px 0px 8px 0px" }}
                  dropdownStyle={{ top: "90px" }}
                  labelText={("Category type")}
                  isRequired={true}
                  dropdownOpen={this.state.so}
                  placeholder={("Select category type")}
                  title={
                    selectedCategory
                  }
                  id="dropdown-recurring"
                  onClick={() => this.setState({ so: !this.state.so })}
                  data={this.getPillarValues()}   
                  onSelect={this.onSelectCategory}
                  active={selectedCategory}
                  itemValue={true}
                  valueIndex={0}
                  onSelectParameter={["category_text", "id"]}
                  // onSelectParameter={["month", "id", "theme_icon"]}
                  dropIcon={true}
                  labelMargin={"0px"}
                  fontSize={"14px"}
                />
                {/* 
                <InputContainer>
                  <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"}>{this.props.t("Category type")}{<span>*</span>}</StyledLabel>
                  <StyledInputV2
                    placeholder={this.props.t("Select category type")}
                    name="title"
                    onChange={this.onChangeInput}
                    value={this.state.title}
                    maxLength="30"
                    style={{background:"white"}}
                    pColor={"#BDBDBD"}
                    color="#184A61"
                    border={"1px solid #BDBDBD"}
                  />
                  <div className="count">{this.state.title?.length}/30 | C</div>
                </InputContainer> */}

                <Border style={{ background: '#EFEFEF', margin: '20px 0 8px 0px',display:"flex" }}/>

                <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" marginb="12px" symbolSize={"14px"}>{this.props.t("Image")}{<span>*</span>} <span className="subtext">{("(use illustration)")}</span></StyledLabel>
                <CommonImageUploader
                  imgSrc={this.state.imgSrc}
                  t={t}
                  closeIcon={closeIcon}
                  UploadIcon={UploadHDMIcon}
                  onImageChange={this.onChange}
                  onRemoveImage={this.removePhoto}
                />
                <Border style={{ background: '#EFEFEF', margin: '8px 0 8px 0px' }} />

                <InputContainer  isColorError={charCount > 3000 ? true : false}>
                  <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"}>{this.props.t("About the challenge")}{<span>*</span>}</StyledLabel>
                  <EditorContainer>
                    <Editor content={description} onChange={this.onChangeDescription} />
                  </EditorContainer>
                  <div className="char-count">{charCount}/3000 | C</div>
                </InputContainer>
              </div>
            </div>
          </Container>
        </div>
      </Layout>
    );
  };

  toggleRadioButton = (value) => {
    this.setState({ selectedOption: value }, () => { });
  };

  onSelectPoints = (name, /*value, key*/) => {
    this.setState({
      [name]: name.value,
      eventPointKey: name.key,
      pointValue: name.value,
    });
  };

  onDropDownSelect = (key, item) => {
    this.setState({
      [key]: item
    });
  };

  onDropDownSelectCoach = (name, id, value) => {
    this.setState({
      [name]: id,
      coachName: value
    });
  };

  stepTwoForm = () => {
    const {
      step,
      goldBadgeImgSrc,
      silverBadgeImgSrc,
      bronzeBadgeImgSrc,
     
    } = this.state;

    const { t } = this.props;



    return (
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container color="#005C87" isFormWidth={"932px"} isHeight={"0px"}>
            <div className="stepsNameHighlight">
              <StepsHeading stepCount={step} type="wellness-challenge" />
            </div>
            <div className="form">
            
              <div className="formBody" style={{display:"flex",gap:"20px"}}>
                <div>
                  <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" marginb="12px" symbolSize={"14px"}>{this.props.t("Gold Badge")} </StyledLabel>
                  <CommonImageUploader
                    imgSrc={goldBadgeImgSrc}
                    t={t}
                    closeIcon={closeIcon}
                    UploadIcon={UploadHDMIcon}
                    onImageChange={this.onChangeGoldImage}
                    onRemoveImage={this.removeGoldImage}
                    ImageType={".svg, .png"}
                  />
                </div>
                <div>
                  <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" marginb="12px" symbolSize={"14px"}>{this.props.t("Silver Badge")} </StyledLabel>
                  <CommonImageUploader
                    imgSrc={silverBadgeImgSrc}
                    t={t}
                    closeIcon={closeIcon}
                    UploadIcon={UploadHDMIcon}
                    onImageChange={this.onChangeSilverImage}
                    onRemoveImage={this.removeSilverImage}
                    ImageType={".svg, .png"}
                  />
                </div>
                <div>
                  <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" marginb="12px" symbolSize={"14px"}>{this.props.t("Bronze Badge")}</StyledLabel>
                  <CommonImageUploader
                    imgSrc={bronzeBadgeImgSrc}
                    t={t}
                    closeIcon={closeIcon}
                    UploadIcon={UploadHDMIcon}
                    onImageChange={this.onChangeBronzeImage}
                    onRemoveImage={this.removeBronzeImage}
                    ImageType={".svg, .png"}
                  />
                </div>
              </div>
            </div>
          </Container>
        </div>
      </Layout>
    );
  };

  render() {
    const {
   
      description,
      imgSrc,
      goldBadgeImgSrc,
      silverBadgeImgSrc,
      bronzeBadgeImgSrc,
      charCount,
      step,
     
    } = this.state;

    // const isDisabled = !goldBadgeImgSrc || !silverBadgeImgSrc|| !bronzeBadgeImgSrc;



   
    return (
      <React.Fragment>
        {step === 1 ? this.stepOneForm() : this.stepTwoForm()}
        {step === 1 ? (
          <ButtonContainer>
            <Main>
              <CommonButtonPopup height="48px" width="200px" margin="auto 0 auto auto" disabled={!imgSrc|| !description || (charCount > 3000)} onClick={!imgSrc|| !description || (charCount > 3000) ? null: () => this.updateStep(2)}>
               Next
              </CommonButtonPopup>
            </Main>
          </ButtonContainer>
        ) : (
          <ButtonContainer>
            <div className="wrapper">

              <CommonButtonBorder width="200px" height="48px"
                onClick={() => this.updateStep(1)}
                margin="auto auto auto 0px">
                 Back
              </CommonButtonBorder>

              <CommonButtonPopup height="48px" width="200px" margin="auto 0 auto auto" 
                disabled={!goldBadgeImgSrc || !silverBadgeImgSrc|| !bronzeBadgeImgSrc}
                onClick={() => this.saveOndemandEvent()}
              >
                 Create Category 
                {/* {RecognitionTickIcon(isDisabled ? "#989898" : "white", 15,10)} */}
              </CommonButtonPopup>
            </div>
          </ButtonContainer>
        )}
      </React.Fragment>
    );
  }
}

CreateCategoryForm.propTypes = {
  createOndemand: PropTypes.func.isRequired,
  fetchOndemandCategory: PropTypes.func,
  ondemandCategory: PropTypes.array,
  history: PropTypes.object.isRequired,
  t: PropTypes.func,
  fetchOndemandEventDetailsById: PropTypes.func.isRequired,
  ondemandEventDetail: PropTypes.object,
  isEditCategory: PropTypes.object,
  EditOndemandEventVideo: PropTypes.func,
};





export default (withTranslation()(CreateCategoryForm));